export interface IFilialOptionsList {
  value: string;
  label: string;
}
export const filialTypeList: IFilialOptionsList[] = [
  { value: "C001", label: "Manaus" },
  { value: "C002", label: "Cruzeiro do Sul" },
  { value: "C003", label: "Porto Velho" },
  { value: "C004", label: "Vilhena" },
  { value: "C005", label: "Várzea Grande" },
  { value: "C006", label: "Rio Branco" },
  { value: "C008", label: "Itaituba" },
  { value: "C009", label: "Belém" },
  { value: "C010", label: "Paranaguá" },
  { value: "C011", label: "Santarém" },
  { value: "C012", label: "Sinop" },
  { value: "C013", label: "Caracaraí" },
  { value: "C080", label: "Campo Grande 1" },
  { value: "C081", label: "Campo Grande 2" },
  { value: "C082", label: "Paulínia" },
];

export const getLabelFilialTypeList = (filialValue) => {
  return filialTypeList.find((filialType) => filialType.value === filialValue)
    ?.label;
};

export const findLabelByValueOrLabelInFilialList = (
  filialAny: string
): IFilialOptionsList | null => {
  const find =
    filialTypeList.find(
      (item) => item.label === filialAny || item.value === filialAny
    ) ?? null;
  return find;
};
